<!-- This route is still a placeholder — there is no review content to render yet.
     Rather than leaving raw scaffold text on a live URL, it now shows the shared
     empty state so the page reads as part of the product. -->
<div class="page_heading">
  <div class="container">
    <h2>Reviews</h2>
  </div>
</div>

<section class="rs-section ur" rsParallax>
  <div class="rs-deco" aria-hidden="true">
    <span class="rs-blob rs-blob--purple rs-blob--tl"></span>
    <span class="rs-blob rs-blob--pink rs-blob--br"></span>
    <span class="rs-dots rs-dots--a"></span>
    <span class="rs-spark" style="--sx: 18%; --sy: 40%; --sd: 0.5s"></span>
    <span class="rs-spark" style="--sx: 80%; --sy: 30%; --sd: 2s"></span>
  </div>

  <div class="rs-shell rs-shell--narrow">
    <div class="rs-empty ur__empty" rsReveal="up" rsRevealImmediate>
      <span class="rs-empty__ico" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M12 3.5l2.6 5.6 6.1.8-4.5 4.2 1.2 6-5.4-3-5.4 3 1.2-6L3.3 9.9l6.1-.8L12 3.5z"
            stroke="currentColor" stroke-width="1.7" stroke-linejoin="round" />
        </svg>
      </span>
      <p class="rs-empty__title">Reviews are on the way</p>
      <p class="rs-empty__text">
        We are collecting verified feedback from our clients. In the meantime you can
        read what teams say about us on the home page, or talk to us directly.
      </p>
      <div class="ur__actions">
        <a routerLink="/" class="rs-btn rs-btn--primary rs-btn--sm" rsRipple>
          <span>See client stories</span>
          <span class="rs-btn__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none">
              <path d="M5 12h13M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
        </a>
        <a routerLink="/contact-us" class="rs-btn rs-btn--ghost rs-btn--sm rs-btn--flat">Contact us</a>
      </div>
    </div>
  </div>
</section>
